import { LoanPurpose } from '@appTypes/LoansApi.interface'

export const loanPurposeOptions = [
    {
        label: 'Consolidate other debts',
        value: LoanPurpose.ConsolidateOtherDebts,
    },
    { label: 'Holiday', value: LoanPurpose.Holiday },
    {
        label: 'Home improvement',
        value: LoanPurpose.HomeImprovement,
    },
    {
        label: 'Vehicle purchase',
        value: LoanPurpose.VehiclePurchase,
    },
    { label: 'Wedding', value: LoanPurpose.Wedding },
    { label: 'Other', value: LoanPurpose.Other },
]
